import React, { useState, useEffect } from "react"; 
import * as apiUrl from "../../apiUrl";

function HomeParallax() {
  const [HomeLastSection, setHomeLastSection] = useState({});

  useEffect(() => {
    const fetchHomeLastSection = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/home/last-image-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomeLastSection(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchHomeLastSection();
  }, []);

  return (

    <div className="home-parallax-sec">
      {" "}
      <img
        src={apiUrl.apiUrl + `/` + HomeLastSection.last_image}
        className="img-fluid"
        alt="Marquis Real Estate Developer in Dubai"
        data-aos="fade-up"
      />{" "}
    </div>

  );
}

export default HomeParallax;
